<template>
    <div class="titles">
        <div></div>
        <div>
            <slot></slot>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {
            
        }
    }
}
</script>
<style lang='scss' scoped>
.titles {
    display: flex;
    align-items: center;
    margin-left: 24px;
    div:nth-child(1) {
        width: 6px;
        height: 32px;
        background: #318544;
        margin-right: 12px;
    }
    div:nth-child(2) {
        font-size: 32px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #318544;
    }   
}
</style>